// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__9ViVv","spin":"spinner_spin__1BDTO"};